import React from 'react';
import { Button } from 'ui-toolkit/index';
import { Jurisdiction } from './Jurisdiction';
import { createDefaultJurisdictionData, IJurisdictionData } from 'ui-toolkit/taxCertifications/IJurisdiction';
import { ITaxCertificationData } from 'ui-toolkit/taxCertifications/ITaxCertification';
import { Field, FieldArray } from 'formik';
import { NewOrderSpaceWrapping } from '../../orderCreation/wrappers/NewOrderSpaceWrapper';
import { IFieldChildProps } from '../../../ui-toolkit/utilities/formikUtilities';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';

export interface IJurisdictionsProps {
  baseName: string;
}

export const Jurisdictions: React.FC<IJurisdictionsProps> = ({ baseName }) => {
  return (
    <Field name={baseName}>
      {({ field }: IFieldChildProps<IJurisdictionData[], ITaxCertificationData>) => (
        <FieldArray name={baseName}>
          {({ remove, push }) => (
            <>
              {field.value.map((item, index) => (
                <Jurisdiction
                  key={`jurisdiction.${item.id}`}
                  baseName={`${baseName}.${index}`}
                  index={index}
                  onRemove={() => remove(index)}
                  canDelete={field.value.length > 1}
                />
              ))}
              <NewOrderSpaceWrapping>
                <Button
                  intent="secondary"
                  type={'button'}
                  onClick={() => push(createDefaultJurisdictionData())}
                  data-test-id={mergeTests('jurisdictions', `add`)}
                >
                  + Add Jurisdiction
                </Button>
              </NewOrderSpaceWrapping>
            </>
          )}
        </FieldArray>
      )}
    </Field>
  );
};
